import { AlbumDetail } from '@bpm-web-app/components/pages';

const AlbumDetailPage = () => (
    <AlbumDetail />
);

export default AlbumDetailPage;
